import { Input } from '@mantine/core'

const disabledInputStyles = {
  borderColor: 'var(--mantine-color-gray-2)',
  backgroundColor: 'var(--mantine-color-gray-0)',
  color: 'var(--gray-40-color)',
  cursor: 'not-allowed',
  opacity: 1,
}

export default {
  Input: Input.extend({
    styles: (_theme, params) => {
      const inputParams = params as { disabled?: boolean }

      return {
        input: {
          borderRadius: '8px',
          ...(inputParams.disabled ? disabledInputStyles : {}),
        },
      }
    },
  }),
}
